import { Box, Stack, Typography } from "@mui/material";
import {
    formatDateTimeShort,
    formatDurationHMS,
} from "../../../utils/formatTime";

import { MODEL_PROPTYPES } from "../../../models";
import PropTypes from "prop-types";
import { SettingsApplications } from "@mui/icons-material";
import { useState } from "react";

JobNodeProcessInfo.propTypes = {
    process: PropTypes.shape(MODEL_PROPTYPES.Process).isRequired,
};

export function JobNodeProcessInfo({ process }) {
    const [isExpanded, setIsExpanded] = useState(false);

    const onClick = () => setIsExpanded(!isExpanded);

    const duration =
        process.startDatetime && process.endDatetime
            ? formatDurationHMS(process.startDatetime, process.endDatetime)
            : null;

    return (
        <Box
            onClick={onClick}
            sx={{
                backgroundColor: "#f5f5f5",
                "&:hover": {
                    backgroundColor: "#e8e8e8",
                },
                transition: "background-color 0.2s",
                p: 1,
                borderRadius: 1,
                cursor: "pointer",
            }}
        >
            {isExpanded ? (
                <Stack>
                    {process.startDatetime && (
                        <InfoRow
                            label="Start:"
                            value={formatDateTimeShort(process.startDatetime)}
                        />
                    )}
                    {process.endDatetime && (
                        <InfoRow
                            label="End:"
                            value={formatDateTimeShort(process.endDatetime)}
                        />
                    )}
                    {duration && (
                        <InfoRow label="Duration:" value={duration} bold />
                    )}
                    {process.validatedDatetime && (
                        <InfoRow
                            label="Validated:"
                            value={formatDateTimeShort(
                                process.validatedDatetime
                            )}
                        />
                    )}
                    {process.rejectionReason && (
                        <InfoRow
                            label="Rejection:"
                            value={process.rejectionReason}
                            error
                        />
                    )}
                    <InfoRow label="UUID:" value={process.uuid} />
                    {process.comment && (
                        <InfoRow label="Comments:" value={process.comment} />
                    )}
                </Stack>
            ) : (
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    spacing={1}
                >
                    <SettingsApplications
                        sx={{
                            fontSize: "1rem",
                            color: "text.secondary",
                        }}
                    />
                    <Typography
                        variant="caption"
                        sx={{
                            fontSize: "0.65rem",
                            color: "text.secondary",
                        }}
                    >
                        Process Info
                    </Typography>
                </Stack>
            )}
        </Box>
    );
}

function InfoRow({ label, value, bold = false, error = false }) {
    return (
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography
                variant="caption"
                color="text.secondary"
                fontSize="0.65rem"
            >
                {label}
            </Typography>
            <Typography
                variant="caption"
                fontSize="0.65rem"
                sx={{
                    fontFamily: "monospace",
                    fontWeight: bold || error ? "bold" : undefined,
                    color: error ? "error.main" : undefined,
                }}
            >
                {value}
            </Typography>
        </Box>
    );
}
